import React from 'react';
import { BoltIcon } from '../icons';
import { Tooltip } from '../Tooltip';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';
import { usePetParentReportActions } from '../../hooks/usePetParentReports';
import { trackEvent } from '../../services/analytics';

interface StatusRoundelProps {
  lastDataReceivedDate?: string | null;
  className?: string;
  align?: 'left' | 'center' | 'right' | 'top' | undefined;
}

export const StatusRoundel: React.FC<StatusRoundelProps> = ({
  lastDataReceivedDate,
  className = '',
  align,
}) => {
  const { t } = useTranslation();
  const { downloadOptinGuide } = usePetParentReportActions();

  const handleOptInGuideClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    trackEvent({
      action: 'opt-in_guide',
      category: 'automated_reporting',
      label: t(TranslationKeyEnum.HillsOptInGuide) ?? '',
    });
    downloadOptinGuide();
  };

  const tooltipContent = (
    <div className="w-[360px] p-4">
      <div className="flex items-start gap-2 mb-3">
        <BoltIcon width={10} height={15} fill="white" className="mt-0.5 flex-shrink-0" />
        <div className="text-sm font-normal text-white leading-[1.375]">
          {t(TranslationKeyEnum.PetszelReportsTooltipTitle)}
        </div>
      </div>
      <div className="text-sm font-normal text-white leading-[1.375] ml-4">
        {t(TranslationKeyEnum.PetszelReportsTooltipDescription).split('Automation Guide')[0]}
        <button
          className="underline bg-transparent p-0 m-0 text-white hover:text-white/90 cursor-pointer"
          onClick={handleOptInGuideClick}
        >
          {t(TranslationKeyEnum.HillsOptInGuide)}
        </button>
      </div>
    </div>
  );

  return (
    <Tooltip align={align} content={tooltipContent} tooltipClassName="w-auto px-3">
      <div
        className={`inline-flex items-center gap-1 px-3 py-1.5 border border-black/60 bg-white rounded-full hover:bg-gray-50 transition-colors ${className}`}
      >
        <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0">
          <BoltIcon width={8} height={12} />
        </div>
        <span className="text-sm font-medium text-gray-700">
          {t(TranslationKeyEnum.Updated)} {lastDataReceivedDate}
        </span>
      </div>
    </Tooltip>
  );
};
